import React from 'react';
import AutoRechargePanel from './AutoRechargePanel';

interface Props {
  organizationId: string;
  organizationName?: string;
  editable: boolean;
  onClose: () => void;
}

/** Credit Accounts → row → Auto-recharge. The panel itself is reusable (My billing). */
const AutoRechargeModal: React.FC<Props> = ({ organizationId, organizationName, editable, onClose }) => (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" role="dialog" aria-modal="true">
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
          Auto-recharge{organizationName ? ` — ${organizationName}` : ''}
        </h2>
        <button onClick={onClose} className="text-gray-500 hover:text-gray-700 dark:text-gray-400" aria-label="Close">
          ✕
        </button>
      </div>
      <AutoRechargePanel organizationId={organizationId} editable={editable} />
    </div>
  </div>
);

export default AutoRechargeModal;
